import { createSelector } from "reselect";

//Configuration
import { lockStateConfiguration } from "src/constants/filters_configurations/exports";

export const lockStateFilterConfigSelector = createSelector(
  () => lockStateConfiguration
);
